import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message'
import Loader from '../components/Loader'
import FormContainer from '../components/FormContainer'
import { login } from '../actions/userActions'

const LoginScreen = ({ location, history }) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const dispatch = useDispatch()

  const userLogin = useSelector((state) => state.userLogin)
  const { loading, error, userInfo } = userLogin

  const redirect = location.search ? location.search.split('=')[1] : '/'

  useEffect(() => {
    if (userInfo) {
      history.push(redirect)
    }
  }, [history, userInfo, redirect])

  const submitHandler = (e) => {
    e.preventDefault()
    dispatch(login(email, password))
  }

  return (

    <div className="max-w-screen-sm  mx-auto pt-32">
      <h1>Sign In</h1>
      {error && <Message variant='danger'>{error}</Message>}
      {loading && <Loader />}
      <form className="w-full p-3 " onSubmit={submitHandler}>
        <div controlId='email'>
          <div>Email Address</div>
          <div className="border my-2">
            <input
              className="outline-none w-full px-2 py-2 bg-transparent "
              type='email'
              placeholder='Enter email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            ></input>
          </div>
          
        </div>

        <div controlId='password'>
          <div>Password</div>
          <div  className="border my-2">
            <input
              type='password'
              className="outline-none w-full px-2 py-2 bg-transparent"
              placeholder='Enter password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            ></input>
          </div>
        </div>

        <button className="py-2 px-4  flex text-center text-gray-50 bg-black" type='submit' >
          Sign In
        </button>
      </form>

      <div className='py-3'>
        <div>
          New Customer?{' '}
          <Link to={redirect ? `/register?redirect=${redirect}` : '/register'}>
            Register
          </Link>
        </div>
      </div>
    
    </div>
  )
}

export default LoginScreen
